import { withSentryRouting } from '@sentry/react';
import { Route as ReactRouterRoute } from 'react-router-dom';
import { environmentVars } from 'constants/services';
import { NODE_ENV } from 'constants/environment';

const isSentryEnabled = NODE_ENV === 'production' && environmentVars.SENTRY_DSN;

const Route = isSentryEnabled
  ? withSentryRouting(ReactRouterRoute)
  : ReactRouterRoute;

export { Route };
